import { ConnectedProps, connect } from 'react-redux'
import { ButtonPrimaryInfoLeft } from '../../../../../../baseComponents/Button'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import PermissionChecker from '../../../../../../baseComponents/PermissionChecker'
import { BaseScreenTableSimpleStateless, useBaseScreenTableLogic } from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { BaseScreenPageData } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import withLoading from '../../../../../../utils/hoc/withLoading'
import { SetEditDeleteModalTy } from '../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { SpecificPriceRulesPayload } from '../../../../../../utils/reducers/products/specificPriceRules'
import ModalCreateServiceConnect from './ModalCreateService'
import ModalChangeActiveService from './ModalChangeActiveService'
import TableServices from '../../../../../../specificComponents/Product/Tables/TableServices'
import { faPlus } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../../../../../baseComponents/TwinIcon'


type ServicesProps = ComponentWithPermissions & ReduxServices & {}

const Services: React.FC<ServicesProps> = ({ userPermissions, ...button }) => {
    const { openModal, setOpenModal, tableInstance, setTableInstance } = useBaseScreenTableLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('services', 'Servicios'),
        newText: t('newService', 'Nuevo servicio'),
    }

    return (
        <BaseScreenTableSimpleStateless TableComponent={TableServices} {...{ pageData, userPermissions, updateTableInstance }} CreateModalComponent={ModalCreateServiceConnect} DeleteModalComponent={ModalChangeActiveService} logicProps={{ openModal, setOpenModal, tableInstance, setTableInstance }} RightHeader={
            <RightHeaderServicesTable {...{ pageData, setOpenModal, ...button, userPermissions }} />
        }>
        </BaseScreenTableSimpleStateless>)
}

type RightHeaderServicesTableProps = ComponentWithPermissions & ReduxServices & {
    pageData: BaseScreenPageData
    setOpenModal: SetEditDeleteModalTy
}

const RightHeaderServicesTable: React.FC<RightHeaderServicesTableProps> = ({ pageData, userPermissions, specificPriceRules, setOpenModal }) => {
    const { t } = useTwinTranslation()
    return (
        <PermissionChecker userPermissions={userPermissions} permission='create'>
            {pageData.newText ? <ButtonPrimaryInfoLeft onClick={async () => setOpenModal({ type: 'create', allRowData: {} })} textButton={<span><TwinIcon icon={faPlus} className='mr-8' />{pageData.newText}</span>} buttonIsDisabled={specificPriceRules?.arrSorted?.length === undefined || specificPriceRules?.arrSorted?.length === 0} infoMessage={t('needCreatePriceRulesBefore', 'Debes crear un grupo de tarifas antes')} /> : null}
        </PermissionChecker>
    )
}

const servicesDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

const mapServicesConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const servicesConnect = connect(mapServicesConnector, servicesDispatch)
type ReduxServices = ConnectedProps<typeof servicesConnect>

const servicesConnectLoading = withLoading(Services, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const ServicesConnect = servicesConnect(servicesConnectLoading)

export default ServicesConnect